(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wotobeus-community"] && !Shopify.designMode) return;
  try {
    
class WotobeusCommunity extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.cards = [...this.querySelectorAll('[data-card]')];
    this.pool = [...this.querySelectorAll('[data-review]')];
    this.dialog = this.querySelector('dialog');
    this.pauseButton = this.querySelector('[data-pause]');
    this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.pauseButton.setAttribute('aria-pressed', String(this.paused));
    this.next = this.cards.length;
    this.slot = 0;
    this.pauseButton.addEventListener('click', () => {
      this.paused = !this.paused;
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
    }, {signal});
    this.cards.forEach(card => card.addEventListener('click', () => {
      const detail = this.querySelector('[data-detail]');
      detail.replaceChildren(this.pool[Number(card.dataset.index)].content.cloneNode(true));
      this.dialog.showModal();
    }, {signal}));
    this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), {signal});
    this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, {signal});
    if (this.pool.length > this.cards.length) this.timer = setInterval(() => this.rotate(), 2600);
  }
  disconnectedCallback() { this.controller?.abort(); clearInterval(this.timer); clearTimeout(this.swapTimer); }
  rotate() {
    if (this.paused || document.hidden || this.dialog.open || this.matches(':hover') || this.contains(document.activeElement)) return;
    const shown = new Set(this.cards.map(card => Number(card.dataset.index)));
    let next = this.next % this.pool.length;
    while (shown.has(next)) next = (next + 1) % this.pool.length;
    const card = this.cards[this.slot % this.cards.length];
    card.classList.add('is-fading');
    this.swapTimer = setTimeout(() => {
      if (!this.isConnected) return;
      card.replaceChildren(this.pool[next].content.cloneNode(true));
      card.dataset.index = String(next);
      card.classList.remove('is-fading');
      this.next = next + 1;
      this.slot++;
    }, 460);
  }
}
if (!customElements.get('wotobeus-community')) customElements.define('wotobeus-community', WotobeusCommunity);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wotobeus-comparison"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('wotobeus-comparison')){
customElements.define('wotobeus-comparison',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;
  this.ready=true;
  const input=this.querySelector('input');
  input.addEventListener('input',()=>{this.style.setProperty('--reveal',input.value+'%');input.setAttribute('aria-valuetext',input.value+'%')});
 }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wotobeus-globe-product"]) return;
  try {
    
class WotobeusGlobeForm extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const select=this.querySelector('[data-globe-variant]'),panel=this.querySelector('[data-globe-engraving]'),field=this.querySelector('[data-globe-text]'),price=this.querySelector('[data-globe-price]'),form=this.querySelector('form');
const sync=()=>{const option=select.selectedOptions[0];const engraved=option.dataset.engraved==='true';panel.hidden=!engraved;field.disabled=!engraved;field.required=engraved;price.textContent=option.dataset.price;};
select.addEventListener('change',sync);
form.addEventListener('submit',event=>{sync();if(!field.disabled&&!field.value.trim()){field.setCustomValidity('Lütfen yazılmasını istediğiniz metni girin.');event.preventDefault();field.reportValidity();}});
field.addEventListener('input',()=>field.setCustomValidity(''));sync();
}
}
if(!customElements.get('wotobeus-globe-form'))customElements.define('wotobeus-globe-form',WotobeusGlobeForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wotobeus-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wotobeus-storefront')) {
  customElements.define('wotobeus-storefront', class extends HTMLElement {
    connectedCallback() {
      this.stopSwipeHint();
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const control = event.target.closest('[data-wb-filter]');
        if (!control || !this.contains(control) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = control.dataset.wbFilter;
        const shelves = Array.from(this.querySelectorAll('[data-wb-shelf]'));
        if (target !== 'all' && !shelves.some((shelf) => shelf.dataset.wbShelf === target)) return;
        event.preventDefault();
        for (const shelf of shelves) shelf.hidden = target !== 'all' && shelf.dataset.wbShelf !== target;
        for (const link of this.querySelectorAll('a[data-wb-filter]')) {
          if (link === control) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        }
        const reset = this.querySelector('button[data-wb-filter="all"]');
        if (reset) reset.setAttribute('aria-pressed', String(target === 'all'));
      }, { signal: this.controller.signal });
      this.startSwipeHint();
    }
    startSwipeHint() {
      if (this.dataset.swipeIntro !== 'true' || !this.classList.contains('wb-app') || window.Shopify?.designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      try { if (sessionStorage.getItem('wb-page-grip-intro-v3')) return; } catch { return; }
      const hint = this.querySelector('.wb-swipe-hint');
      if (!hint) return;
      this.pullHint = hint;
      document.body.appendChild(hint);
      this.swipeController = new AbortController();
      const stop = () => this.stopSwipeHint();
      for (const name of ['pointerdown', 'touchstart', 'wheel', 'keydown']) window.addEventListener(name, stop, { once: true, passive: true, signal: this.swipeController.signal });
      this.swipeTimer = window.setTimeout(() => {
        if (window.scrollY > 40) { this.stopSwipeHint(); return; }
        try { sessionStorage.setItem('wb-page-grip-intro-v3', 'seen'); } catch { this.stopSwipeHint(); return; }
        hint.hidden = false;
        document.documentElement.classList.add('wb-page-pull-active');
        this.swipeEndTimer = window.setTimeout(stop, 3500);
      }, 0);
    }
    stopSwipeHint() {
      window.clearTimeout(this.swipeTimer);
      window.clearTimeout(this.swipeEndTimer);
      this.swipeController?.abort();
      document.documentElement.classList.remove('wb-page-pull-active');
      const hint = this.pullHint || this.querySelector('.wb-swipe-hint');
      if (hint) { hint.hidden = true; this.appendChild(hint); }
    }
    disconnectedCallback() { this.stopSwipeHint(); this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wotobeus-thermos-product"]) return;
  try {
    
class WotobeusThermosForm extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const select=this.querySelector('[data-globe-variant]'),panel=this.querySelector('[data-globe-engraving]'),field=this.querySelector('[data-globe-text]'),price=this.querySelector('[data-globe-price]'),form=this.querySelector('form');
const sync=()=>{const option=select.selectedOptions[0];const engraved=option.dataset.engraved==='true';panel.hidden=!engraved;field.disabled=!engraved;field.required=engraved;price.textContent=option.dataset.price;};
select.addEventListener('change',sync);
form.addEventListener('submit',event=>{sync();if(!field.disabled&&!field.value.trim()){field.setCustomValidity('Lütfen yazılmasını istediğiniz metni girin.');event.preventDefault();field.reportValidity();}});
field.addEventListener('input',()=>field.setCustomValidity(''));sync();
}
}
if(!customElements.get('wotobeus-thermos-form'))customElements.define('wotobeus-thermos-form',WotobeusThermosForm);
class WotobeusThermosGallery extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('.wb-thermos-track');this.querySelector('[data-prev]').addEventListener('click',()=>track.scrollBy({left:-track.clientWidth,behavior:'smooth'}));this.querySelector('[data-next]').addEventListener('click',()=>track.scrollBy({left:track.clientWidth,behavior:'smooth'}));}}if(!customElements.get('wotobeus-thermos-gallery'))customElements.define('wotobeus-thermos-gallery',WotobeusThermosGallery);
  } catch(e) { console.error(e); }
})();
})();
